import React, { useRef } from 'react';
import Buttons from '../Constans/Buttons';
import { useEffect, useState } from 'react';
import PaymentCG from '../../SaleBlock/PaymentCG/PaymentCG';
import { cgTypeEnum } from '../../../../utilities/enums/cgTypeEnum';
import { Container, FormGroup, Input, Label, Row } from 'reactstrap';
import PopUp from '../../../Shared/Popup/PopUp';
import JoiningFormPopUp from '../PopUps/JoiningFormPopUp';
import ServicesFormPopUp from '../PopUps/ServicesFormPopUp';
import { CreditCardValidation } from '../IdfSaleSlice';
import { useDispatch } from 'react-redux';
import { ErrorCode } from '../IdfSaleEnums';
import ErrorPage from '../PopUps/ErrorPage';
import { resetStore, clearUrl } from '../../../Block/SaleBlock/PaymentCG/PaymentCGSlice';
import { isMobile } from 'react-device-detect';
import { buildUrlAndOpenWindow, isNullOrEmpty } from '../../../../utilities/StringHelpers/StringHelpers';
import { dwhReport, dwhDictionary } from '../dwhReports/dwhGeneralReport';

function PersonalInfoStepTwo(props) {
  const dispatch = useDispatch();
  const { idfStore: store } = props;
  const [isShowJoiningPopUp, setIsShowJoiningPopUp] = useState(false);
  const [isShowServicesPopUp, setIsShowServicesPopUp] = useState(false);

  const [creditCardError, setCreditCardError] = useState({ error: false, type: null });
  const renderCount = useRef(0);
  const [didTryToContinue, setDidTryToContinue] = useState(false);

  const [formErrors, setFormErrors] = useState({
    isJoiningFormError: false,
    isServicesFormError: false,
    acceptSecurityError: false,
    acceptAuctionError: false,
  });
  const validateForm = () => {
    const errors = {
      isJoiningFormError: false,
      isServicesFormError: false,
      acceptSecurityError: false,
      acceptAuctionError: false,
    };
    if (!store.isJoiningFormValid) {
      errors.isJoiningFormError = true;
    }
    if (!store.isServiceFormValid) {
      errors.isServicesFormError = true;
    }
    if (!store.acceptSecurity) {
      errors.acceptSecurityError = true;
    }
    if (!store.acceptAuction) {
      errors.acceptAuctionError = true;
    }
    return errors;
  };
  useEffect(() => {
    if (didTryToContinue) renderCount.current++;
    setDidTryToContinue(false);
    if (renderCount.current > 0) setFormErrors(validateForm());
    else setFormErrors((prevErrors) => Object.fromEntries(Object.keys(prevErrors).map((key) => [key, false])));
  }, [store.isJoiningFormValid, store.isServiceFormValid, store.acceptSecurity, store.acceptAuction]);

  useEffect(() => {
    //props.saveToHistory('PersonalInfoStepTwo');
  }, []);
  const { paymentCg } = props;
  useEffect(() => {
    if (paymentCg.Credit4Digits !== '') {
      CreditCardValidationFunction();
    }
  }, [paymentCg.Credit4Digits]);
  let res;
  async function CreditCardValidationFunction() {
    res = await dispatch(
      CreditCardValidation({
        creditCardType: paymentCg.CCType,
        creditCardNumber: paymentCg.CCToken,
        idNumber: paymentCg.CGData.id,
        isIDF: true,

      }),
    );
    if (res.payload?.isError) {
      const { errorCode } = res.payload;

      setCreditCardError({ error: true, type: errorCode });
      dispatch(resetStore());
    }
  }
  const toggleError = () => {
    setCreditCardError((prevState) => ({
      ...prevState,
      error: !prevState.error,
    }));
  };
  const onClickNavigation = () => {
    setFormErrors(validateForm());
    setDidTryToContinue(true);
    if (store.isJoiningFormValid && store.isServiceFormValid && store.acceptSecurity && store.acceptAuction) {
      renderCount.current = 0;
      dwhReport({ ...dwhDictionary.PersonalInformation_Ongoing })
      return true;
    } else {
      return false;
    }

  };
  return (
    <div className='idf-personal-info phase-two step'>
      {creditCardError.error ? (
        <ErrorPage errorCode={creditCardError.type} setShowPopUp={toggleError} />
      ) : (
        <>
          <Container fluid className='idf-step-header justify-content-center d-flex flex-column align-items-center mb-3'>
            <Row className='idf-title-bold justify-content-center d-flex'>{props.contentData.personalInfoTitle.value}</Row>
            <Row className='idf-line justify-content-center d-flex'></Row>

            <div className='address-header'>
              <Row className='idf-sub-title-bold justify-content-center d-flex'>פרטי כרטיס אשראי</Row>
              <Row className='idf-sub-title justify-content-center d-flex'>מלאו את פרטי האשראי איתו תרצו לשלם</Row>
            </div>
          </Container>
          <Container fluid className=' justify-content-center d-flex flex-column align-items-center'>
            <PaymentCG
              type={cgTypeEnum.CHECKCARD}
              isHideTermsCheckbox
              padding='0'
              showPaymentCount
              noLoader
              edit={isNullOrEmpty(paymentCg.CCToken) || paymentCg.error}
              customerId={store.userDetails?.id_number}
              isShowIdNumber={true}
              isIDF={true}
              isIDFError={creditCardError}
              source="IdfSaleBlock"
            />

            <Row className='idf-sub-title-bold justify-content-center d-flex mt-3'>אישור מסמכים </Row>
            <FormGroup check inline className=' justify-content-center d-flex flex-column '>
              <div className='justify-content-center d-flex align-items-center'>
                <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    d='M22.25 21H8.75a.75.75 0 0 1-.75-.75V3.75A.75.75 0 0 1 8.75 3h9L23 8.25v12a.75.75 0 0 1-.75.75z'
                    fill='#E0C1FF'
                    stroke='var(--theme-primary, #810ea9)'
                    stroke-width='1.5'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                  />
                  <path
                    d='M17.249 3v5.25h5.25M12 12.75h6M12 15.75h6'
                    stroke='var(--theme-primary, #810ea9)'
                    stroke-width='1.5'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                  />
                </svg>
                <Label check>
                  {' '}
                  <a style={{ cursor: 'pointer', color: 'var(--theme-primary, #9631ff)', textDecoration: 'underline' }} onClick={() => setIsShowJoiningPopUp(true)}>
                    לחצו כאן לחתימה על טופס הצטרפות{' '}
                  </a>
                </Label>
              </div>
              {formErrors.isJoiningFormError && <div className={'error'}>אנא מלא טופס הצטרפות</div>}

              <div className='justify-content-center d-flex align-items-center'>
                <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    d='M22.25 21H8.75a.75.75 0 0 1-.75-.75V3.75A.75.75 0 0 1 8.75 3h9L23 8.25v12a.75.75 0 0 1-.75.75z'
                    fill='#E0C1FF'
                    stroke='var(--theme-primary, #810ea9)'
                    stroke-width='1.5'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                  />
                  <path
                    d='M17.249 3v5.25h5.25M12 12.75h6M12 15.75h6'
                    stroke='var(--theme-primary, #810ea9)'
                    stroke-width='1.5'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                  />
                </svg>
                <Label check>
                  {' '}
                  <a
                    style={{ cursor: 'pointer', color: 'var(--theme-primary, #9631ff)', textDecoration: 'underline' }}
                    onClick={() => setIsShowServicesPopUp(true)}>
                    לחצו כאן לחתימה על טופס גישה לשירותים{' '}
                  </a>
                </Label>
              </div>
              {formErrors.isServicesFormError && <div className={'error'}>אנא מלא טופס גישה לשירותים</div>}

              <div className='justify-content-center d-flex align-items-center'>
                <Input
                  className='p-2'
                  dir='rtl'
                  type='checkbox'
                  checked={store.acceptSecurity}
                  onClick={
                    store.isShowSecurityForm.isShow ? (e) => props.setAcceptSecurity(e.target.checked) : () => props.setIsShowSecurityForm({ isShow: false, error: true })
                  }
                />
                <Label check>
                  קראתי ואני מאשר{' '}
                  <a onClick={() => { props.setIsShowSecurityForm({ isShow: true, error: false }); buildUrlAndOpenWindow(props.contentData.informationSecurityForm.value) }} style={{ cursor: 'pointer', textDecoration: 'underline' }}>
                    טופס ביטחון מידע
                  </a>
                </Label>
              </div>
              {
                store.isShowSecurityForm.error ? <div className='error'>אנא צפה בטופס לפני אישורו</div> :
                  formErrors.acceptSecurityError && <div className={'error'}>אנא אשר טופס ביטחון מידע</div>
              }

              <div className='justify-content-center d-flex align-items-center'>
                <Input
                  className='p-2'
                  dir='rtl'
                  type='checkbox'
                  checked={store.acceptAuction}
                  onClick={store.isShowAuction.isShow ? (e) => props.setAcceptAuction(e.target.checked) : () => props.setIsShowAuction({ isShow: false, error: true })}
                />
                <Label check>
                  קראתי ואני מאשר{' '}
                  <a onClick={() => { props.setIsShowAuction({ isShow: true, error: false }); buildUrlAndOpenWindow(props.contentData.cellularAuctionForm.value) }} style={{ cursor: 'pointer', textDecoration: 'underline' }}>
                    טופס עיקרי מכרז הסלולר
                  </a>
                </Label>
              </div>
              {store.isShowAuction.error ? <div className='error'>אנא צפה בטופס לפני אישורו</div> :
                formErrors.acceptAuctionError && <div className={'error'}>אנא אשר טופס עיקרי מכרז הסלולר</div>
              }
            </FormGroup>
          </Container>
          <Buttons
            onClickNavigation={onClickNavigation}
            canContinue={paymentCg.Credit4Digits !== ''}
          />
          <PopUp preventWrapperClose={true} showPopUp={isShowJoiningPopUp} onClose={() => setIsShowJoiningPopUp(false)} className=''>
            <JoiningFormPopUp {...props} setIsShowPopUp={setIsShowJoiningPopUp} />
          </PopUp>
          <PopUp preventWrapperClose={true} showPopUp={isShowServicesPopUp} onClose={() => setIsShowServicesPopUp(false)} className=''>
            <ServicesFormPopUp props={props} setIsShowPopUp={setIsShowServicesPopUp} />
          </PopUp>
        </>
      )}
    </div>
  );
}

export default PersonalInfoStepTwo;
